import { clientAxios } from '../../../config'

export const getSellersMotorBikesData = async ({ fDate, eDate }) => {
    try {
        const resultGetMotorBikeData = await clientAxios.get('/sellers.php', {
            params: {
                fDate: fDate,
                eDate: eDate,
                division: "motos"
            },
        })
        const { result, message = "", error_msg } = resultGetMotorBikeData.data
        return { result, message, error_msg }

    } catch (error) {
        if ("response" in error) {
            const { response } = error
            const { data } = response
            const { result = [], message = "", error_msg = "" } = data
            return { result, message, error_msg }
        } else {
            const result = [], message = "An error has ocurred", error_msg = ""
            return { result, message, error_msg }
        }
    }
}